'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = function () {
	//Don't use dot notation because of IE10
	var consoleName = 'console';
	var consoleFunctions = ['log', 'error', 'warn', 'info'];
	var originalConsoleFunctions = {};
	consoleFunctions.forEach(function (fn) {
		originalConsoleFunctions[fn] = window[consoleName][fn];
	});

	return function (enabled) {
		if (enabled) {
			window.cl = function (x) {
				return console.log(x), x;
			};
			consoleFunctions.forEach(function (fn) {
				window[consoleName][fn] = originalConsoleFunctions[fn];
			});
		} else {
			consoleFunctions.forEach(function (fn) {
				window[consoleName][fn] = function () {
					return undefined;
				};
			});
		}
	};
}();

//debug(false);


function storageAvailable(type) {
	var storage = void 0;

	try {
		storage = window[type];
		var x = '__storage_test__';
		storage.setItem(x, x);
		storage.removeItem(x);
		return true;
	} catch (e) {
		return e instanceof DOMException && (
		// everything except Firefox
		e.code === 22 ||
		// Firefox
		e.code === 1014 ||
		// test name field too, because code might not be present
		// everything except Firefox
		e.name === 'QuotaExceededError' ||
		// Firefox
		e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
		// acknowledge QuotaExceededError only if there's something already stored
		storage.length !== 0;
	}
}

;;var Helpers = {
	//Choose a random number from an interval, including both ends
	rnd: function rnd(from, to, except) {
		var rnd = void 0;
		do {
			rnd = Math.floor(Math.random() * (to - from + 1)) + from;
		} while (typeof except !== 'undefined' && except === rnd);
		return rnd;
	},


	//Shuffles an array in-place
	shuffle: function shuffle(array) {
		var counter = array.length;
		while (counter > 0) {
			var index = Math.floor(Math.random() * counter--);
			var temp = array[counter];
			array[counter] = array[index];
			array[index] = temp;
		}
		return array;
	},


	//Choose a random element from array `items`
	choose: function choose(items) {
		return items.length ? items[Math.floor(Math.random() * items.length)] : null;
	},

	//Returns -1 or 1 randomly, optionally multiplied by `x`
	randomSign: function randomSign() {
		var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		return x * (Math.random() < 0.5 ? 1 : -1);
	},

	//Returns -1 if `x` is positive, 1 otherwise
	negativeSign: function negativeSign(x) {
		return x > 0 ? -1 : 1;
	},

	//Returns the fractional part of a number
	frac: function frac(x) {
		return x - Math.floor(x);
	},

	//Calculates horizontal length of vector (distance, angle)
	distX: function distX(distance, angle) {
		return Math.cos(angle) * distance;
	},

	//Calculates vertical length of vector (distance, angle)
	distY: function distY(distance, angle) {
		return -Math.sin(angle) * distance;
	},

	//Returns the sign of a number (-1, 0 or 1)
	sign: function sign(x) {
		return +x === 0 || isNaN(+x) ? Number(x) : x > 0 ? 1 : -1;
	},

	//Calculates correct modulo even for negative numbers
	mod: function mod(n, _mod) {
		return (n % _mod + _mod) % _mod;
	},

	//Works like Array.reduce but iterates `num` times
	reduceNumber: function reduceNumber(num, fn, val) {
		return num ? fn(Helpers.reduceNumber(--num, fn, val), num) : val;
	},

	//Returns a parameter value from current url
	getURLParameter: function getURLParameter(name) {
		return decodeURIComponent((new RegExp('[?|&]' + name + '=([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
	},

	//Pads `number` with zeroes to a minimum length `len`
	getZeroInt: function getZeroInt(num) {
		var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
		return Helpers.reduceNumber(Math.max(0, len - ('' + num).length), function (s) {
			return '0' + s;
		}, '' + num);
	}
};

;;var PRIORITYQUEUE_DEFAULT_PRIORITY = 0;

var PriorityQueue = function () {
	function PriorityQueue(comparator) {
		_classCallCheck(this, PriorityQueue);

		this._comparator = comparator || function (a, b) {
			return a - b;
		}; //Sort ascending by default
		this._priorities = []; //List of used priorities, always sorted
		this._queues = {}; //Priority-keyed arrays of queued items
		this._callbacks = {
			onBeforeTransform: [], //Called before (and if) transforming items to be added
			onBeforeAdd: [], //Called before adding (transformed) item (addition can be aborted by returning false)
			onAfterAdd: [], //Called after successfully adding an item
			onBeforeRemove: [], //Called before removing item (removal can be aborted by returning false)
			onAfterRemove: [] //Called after successfully removing an item
		};
		this._flags = {
			dirty: false
		};
		this._cachedQueues = []; //An array of all concatenated queues is kept here (result of .getAll())
		this._privateCallbacks = {
			onBeforeAdd: []
		};
		this._transformers = null; //This will be a CallbackQueue holding all input transformers
		this.length = 0; //Total length of the queue (number of items queued)
	}

	//Add an item


	_createClass(PriorityQueue, [{
		key: 'add',
		value: function add(object, priority) {
			for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
				args[_key - 2] = arguments[_key];
			}

			if (typeof priority === 'function') {
				priority = priority();
			}
			if (typeof priority !== 'number') {
				priority = PRIORITYQUEUE_DEFAULT_PRIORITY;
			}
			if (this._transformers !== null) {
				if (this._callbacks.onBeforeTransform.every(function (cb) {
					return cb.apply(undefined, [object, priority].concat(args)) !== false;
				})) {
					//Transformation can be aborted
					object = this._transformers.getAll().reduce(function (obj, transformer) {
						return transformer.apply(undefined, [obj, priority].concat(args));
					}, object); //Apply all transformers sequentially
				}
			}
			this._privateCallbacks.onBeforeAdd.forEach(function (cb) {
				return cb.apply(undefined, [object, priority].concat(args));
			});
			if (this._callbacks.onBeforeAdd.every(function (cb) {
				return cb.apply(undefined, [object, priority].concat(args)) !== false;
			})) {
				//Addition can be aborted
				this._getQueue(priority, true).push(object);
				this.length++;
				this._callbacks.onAfterAdd.forEach(function (cb) {
					return cb.apply(undefined, [object, priority].concat(args));
				});
				this._flags.dirty = true;
				return object; //Return the new (transformed) item
			}
			return undefined;
		}

		//Remove an item

	}, {
		key: 'remove',
		value: function remove(object) {
			var _this = this;

			if (this._callbacks.onBeforeRemove.every(function (cb) {
				return cb(object) !== false;
			})) {
				//Removal can be aborted
				this.length = this._priorities.reduce(function (sum, priority) {
					return sum + _this._setQueue(priority, _this._getQueue(priority).filter(function (obj) {
						return obj !== object;
					})).length;
				}, 0);
				this._callbacks.onAfterRemove.forEach(function (cb) {
					return cb(object);
				});
			}
			return this;
		}

		//Set a different priority for a queued item

	}, {
		key: 'setPriority',
		value: function setPriority(object, priority) {
			this.remove(object).add(object, priority);
			this._flags.dirty = true;
			return this;
		}

		//Set a new priority for all items with some old priority

	}, {
		key: 'reassignPriority',
		value: function reassignPriority(oldPriority, newPriority) {
			if (this._priorities.indexOf(oldPriority) !== -1) {
				//If such old priority exists
				if (this._priorities.indexOf(newPriority) === -1) {
					//No queue with such new priority yet
					this._priorities.push(newPriority); //Add new priority to the list
					this._priorities.sort(this._comparator); //Sort the priorities
					this._setQueue(newPriority, this._getQueue(oldPriority));
				} else {
					//Both priorities in use, concatenate the two queues
					this._setQueue(newPriority, this._getQueue(newPriority).concat(this._getQueue(oldPriority)));
				}
				this._priorities.splice(this._priorities.indexOf(oldPriority), 1); //Remove old priority, list is still sorted
			}
			return this;
		}

		//Get all queued items in an array, possibly filtered by a priority

	}, {
		key: 'getAll',
		value: function getAll(priority) {
			var _this2 = this;

			if (typeof priority === 'number') {
				return this._getQueue(priority);
			}
			if (this._flags.dirty) {
				this._cachedQueues = this._priorities.reduce(function (res, p) {
					return res.concat(_this2._getQueue(p));
				}, []); //Concatenate all partial queues into one
				this._flags.dirty = false;
			}
			return this._cachedQueues;
		}
	}, {
		key: 'getHighestPriority',
		value: function getHighestPriority() {
			return this._priorities.length ? this._priorities[0] : PRIORITYQUEUE_DEFAULT_PRIORITY;
		}
	}, {
		key: 'getLowestPriority',
		value: function getLowestPriority() {
			return this._priorities.length ? this._priorities[this._priorities.length - 1] : PRIORITYQUEUE_DEFAULT_PRIORITY;
		}

		//Add a callback to be fired before transforming new items

	}, {
		key: 'onBeforeTransform',
		value: function onBeforeTransform(callback) {
			this._callbacks.onBeforeTransform.push(callback);
			return this;
		}

		//Add a callback to be fired before adding new (already transformed) items

	}, {
		key: 'onBeforeAdd',
		value: function onBeforeAdd(callback) {
			this._callbacks.onBeforeAdd.push(callback);
			return this;
		}

		//Add a callback to be fired after successfully adding a new item

	}, {
		key: 'onAfterAdd',
		value: function onAfterAdd(callback) {
			this._callbacks.onAfterAdd.push(callback);
			return this;
		}

		//Add a callback to be fired before removing an item

	}, {
		key: 'onBeforeRemove',
		value: function onBeforeRemove(callback) {
			this._callbacks.onBeforeRemove.push(callback);
			return this;
		}

		//Add a callback to be fired after successfully removing an item

	}, {
		key: 'onAfterRemove',
		value: function onAfterRemove(callback) {
			this._callbacks.onAfterRemove.push(callback);
			return this;
		}

		//Add a transformer function to modify any new items being added

	}, {
		key: 'addTransformer',
		value: function addTransformer(transformer, priority) {
			if (this._transformers === null) {
				this._transformers = new CallbackQueue();
			}
			this._transformers.add(transformer, priority);
			return this;
		}

		//========================================================

		//Get or create a new partial queue for a certain priority

	}, {
		key: '_getQueue',
		value: function _getQueue(priority) {
			var createNew = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (this._priorities.indexOf(priority) === -1) {
				//No queue with such priority yet
				if (!createNew) {
					return [];
				}
				this._priorities.push(priority); //Add the priority to the list
				this._priorities.sort(this._comparator); //Sort the list
				this._setQueue(priority, []); //The new queue is empty
			}
			return this._queues[priority];
		}

		//Assign a partial queue to a certain priority

	}, {
		key: '_setQueue',
		value: function _setQueue(priority, queue) {
			this._flags.dirty = true;
			return this._queues[priority] = queue;
		}
	}]);

	return PriorityQueue;
}();

;;var CallbackQueue = function (_PriorityQueue) {
	_inherits(CallbackQueue, _PriorityQueue);

	function CallbackQueue(comparator) {
		_classCallCheck(this, CallbackQueue);

		var _this3 = _possibleConstructorReturn(this, (CallbackQueue.__proto__ || Object.getPrototypeOf(CallbackQueue)).call(this, comparator));

		_this3._privateCallbacks.onBeforeAdd.push(CallbackQueue._typeCheck);
		return _this3;
	}

	_createClass(CallbackQueue, [{
		key: 'fire',
		value: function fire() {
			if (this.length) {
				var args = arguments;
				this.getAll().forEach(function (callback) {
					return callback.apply(undefined, args);
				});
			}
			return this;
		}
	}], [{
		key: '_typeCheck',
		value: function _typeCheck(object) {
			if (typeof object !== 'function') {
				throw new TypeError('Only functions can be added to CallbackQueue.');
			}
		}
	}]);

	return CallbackQueue;
}(PriorityQueue);

;; /* Create a lazy-evaluation wrapper around an object. The properties will be evaluated on their first usage.
   *
   * i.e. `lazy = LazyProps.create({ prop() { return new X(); } });`
   * `lazy.prop` will be an instance of X only after `lazy.prop` has been referenced somewhere. Until that,
   * `lazy` will be an empty object.
   */
var LazyProps = {
	create: function create(obj, thisArg) {
		var res = {};
		Object.keys(obj).filter(function (key) {
			return obj.hasOwnProperty(key);
		}).forEach(function (key) {
			Object.defineProperty(res, key, {
				configurable: true,
				enumerable: true,
				get: function get() {
					Object.defineProperty(this, key, { //Define the property with a value of `undefined`
						configurable: true,
						enumerable: true,
						writable: true
					});
					var value = obj[key].call(thisArg); //Call a function that will return the value to be used
					Object.defineProperty(this, key, { //Overwrite the getter with the actual value
						configurable: true,
						enumerable: true,
						writable: true,
						value: value
					});
					return value;
				},
				set: function set(value) {
					Object.defineProperty(this, key, { //Overwrite getter and setter and store the value
						configurable: true,
						enumerable: true,
						writable: true,
						value: value
					});
					return value;
				}
			});
		});
		return res;
	}
};

;; /**************************************************************************************/
// WEBPAGE ENVIRONMENT OBJECT
/**************************************************************************************/
var W_DEFAULT_DEBOUNCE_TIME = 300;
var W_DEFAULT_KEYBOARD_PARAM = -1;

var WebPage = function () {
	function WebPage() {
		var _this4 = this;

		_classCallCheck(this, WebPage);

		this.callbacks = LazyProps.create({
			init: function init() {
				return new CallbackQueue();
			},
			scroll: function scroll() {
				return LazyProps.create({
					general: _this4._scrollCallbackQueueFactory,
					start: _this4._scrollCallbackQueueFactory,
					active: _this4._scrollCallbackQueueFactory,
					end: _this4._scrollCallbackQueueFactory
				}, _this4);
			},
			resize: function resize() {
				return LazyProps.create({
					general: _this4._resizeCallbackQueueFactory,
					width: function width() {
						return LazyProps.create({
							start: _this4._resizeCallbackQueueFactory,
							active: _this4._resizeCallbackQueueFactory,
							end: _this4._resizeCallbackQueueFactory
						}, _this4);
					},
					height: function height() {
						return LazyProps.create({
							start: _this4._resizeCallbackQueueFactory,
							active: _this4._resizeCallbackQueueFactory,
							end: _this4._resizeCallbackQueueFactory
						}, _this4);
					},
					start: _this4._resizeCallbackQueueFactory,
					active: _this4._resizeCallbackQueueFactory,
					end: _this4._resizeCallbackQueueFactory
				}, _this4);
			},
			layout: function layout() {
				return new CallbackQueue();
			},
			layoutGroup: function layoutGroup() {
				return new CallbackQueue();
			},
			visibility: function visibility() {
				return new CallbackQueue();
			},
			keyboard: this._keyUpCallbackQueueFactory
		}, this);

		this.handlerNames = {
			INIT: 'initHandler',
			RESIZE: 'resizeHandler',
			RESIZE_START: 'resizeStartHandler',
			RESIZE_ACTIVE: 'resizeActiveHandler',
			RESIZE_END: 'resizeEndHandler',
			RESIZE_WIDTH_START: 'resizeWidthStartHandler',
			RESIZE_WIDTH_ACTIVE: 'resizeWidthActiveHandler',
			RESIZE_WIDTH_END: 'resizeWidthEndHandler',
			RESIZE_HEIGHT_START: 'resizeHeightStartHandler',
			RESIZE_HEIGHT_ACTIVE: 'resizeHeightActiveHandler',
			RESIZE_HEIGHT_END: 'resizeHeightEndHandler',
			LAYOUT: 'layoutHandler',
			LAYOUT_GROUP: 'layoutGroupHandler',
			SCROLL: 'scrollHandler',
			SCROLL_START: 'scrollStartHandler',
			SCROLL_ACTIVE: 'scrollActiveHandler',
			SCROLL_END: 'scrollEndHandler',
			VISIBILITY: 'visibilityHandler',
			KEYBOARD: /keyboard(?:\[(\d+)(?:,(\d+))*])?Handler/ //i.e. keyboardHandler, keyboard[27]Handler, keyboard[39,40]Handler
		};

		this.isInitialized = false;
		this.canHandleVisibilityChange = typeof document.hidden !== 'undefined' && !!document.addEventListener;
		this.$html = $('html');
		this.$body = $('body');
		this.$document = $(document);
		this.$window = $(window);

		this.top = this.topLast = this.$window.scrollTop();
		this.width = this.widthLast = this.$window.outerWidth(true);
		this.height = this.heightLast = this.$window.outerHeight();
		this.scrollDirection = 0;
		this.layout = null;
		this.breakpoints = [{ from: 0, to: 460, layout: 'tiny', layoutGroup: 'phone' }, { from: 461, to: 600, layout: 'phone', layoutGroup: 'phone' }, { from: 601, to: 900, layout: 'tablet-portrait', layoutGroup: 'tablet' }, { from: 901, to: 1200, layout: 'tablet-landscape', layoutGroup: 'tablet' }, { from: 1201, to: 1500, layout: 'desktop', layoutGroup: 'desktop' }, { from: 1501, to: 1800, layout: 'desktop-medium', layoutGroup: 'desktop' }, { from: 1801, to: 99999, layout: 'desktop-large', layoutGroup: 'desktop' }];
		this.layouts = this.breakpoints.map(function (b) {
			return b.layout;
		});
		this.isRetina = window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches) || window.devicePixelRatio && window.devicePixelRatio > 1.3;
		this.isStatic = null;
		this.isWindowFocused = true;
		this._flags = {
			scrolling: false,
			resizingWidth: false,
			resizingHeight: false,
			isScrollBound: false,
			isResizeBound: false,
			isKeyUpBound: false
		};
		this._debounce = {
			scrollTimeoutId: -1,
			resizeTimeoutId: -1,
			resizeWidthTimeoutId: -1,
			resizeHeightTimeoutId: -1
		};
		this.device = {
			mobile: bowser.mobile || bowser.tablet,
			tablet: bowser.tablet,
			phone: bowser.mobile,
			ios: bowser.ios,
			os: null,
			osversion: bowser.osversion
		};
		this.browser = {
			name: function () {
				switch (true) {
					case bowser.chrome:
						return "chrome";
					case bowser.safari:
						return "safari";
					case bowser.opera:
						return "opera";
					case bowser.mozilla:
						return "mozilla";
					case bowser.firefox:
						return "firefox";
					case bowser.msie:
						return "ms msie";
					case bowser.msedge:
						return "ms msedge";
				}
			}(),
			version: parseInt(bowser.version),
			webkit: bowser.webkit,
			gecko: bowser.gecko
		};

		//Use like this: if (w.isLayout.smallerThan('desktop')) { ... }
		this.isLayout = {
			smallerThan: function smallerThan(compare) {
				var layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this4.layout;
				return _this4.layouts.indexOf(layout) < _this4.layouts.indexOf(compare);
			},
			smallerOrEqual: function smallerOrEqual(compare) {
				var layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this4.layout;
				return _this4.layouts.indexOf(layout) <= _this4.layouts.indexOf(compare);
			},
			biggerThan: function biggerThan(compare) {
				var layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this4.layout;
				return _this4.layouts.indexOf(layout) > _this4.layouts.indexOf(compare);
			},
			biggerOrEqual: function biggerOrEqual(compare) {
				var layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this4.layout;
				return _this4.layouts.indexOf(layout) >= _this4.layouts.indexOf(compare);
			}
		};

		this.$html.toggleClass('mobileos-android', !!bowser.android);
		this.$html.toggleClass('mobileos-ios', !!bowser.ios);
		this.$html.toggleClass('mobileos-wp', !!bowser.windowsphone);

		this.$html.addClass(this.browser.name);
		this.$html.addClass("v" + this.browser.version);
		this.$html.addClass(this.device.mobile ? "mobileDevice" : 'non-mobileDevice');
		this.$html.addClass(this.canHandleVisibilityChange ? 'visibilityChange' : 'non-visibilityChange');
	}

	//========================================================

	//Initialize the webpage. Don't call this yourself! Should be called only once at the end of the document


	_createClass(WebPage, [{
		key: 'init',
		value: function init() {
			//Handle visibility change
			if (this.canHandleVisibilityChange) {
				this.isWindowFocused = !document.hidden;
				document.addEventListener('visibilitychange', this._visibilityHandler.bind(this));
			}

			//Ready to go!
			this._getLayout();
			this._debounce.isDisabled = false;
			this.isInitialized = true;
			this.callbacks.init.fire();
		}

		//Automatically find handlers in an object and register them

	}, {
		key: 'autoHandle',
		value: function autoHandle(object, priority) {
			var _this5 = this;

			Object.keys(this.handlerNames).forEach(function (key) {
				//Iterate over handler name keys
				var name = _this5.handlerNames[key];
				if (name instanceof RegExp) {
					//Handler name is a RegExp
					Object.keys(object).forEach(function (objKey) {
						var match = name.exec(objKey);
						if (!match) {
							//This handler's name doesn't match the RegExp
							return;
						}
						var handlerParams = match.slice(1).filter(function (p) {
							return p !== undefined;
						}); //Extract all RegExp capture groups
						switch (name) {
							case _this5.handlerNames.KEYBOARD:
								if (handlerParams.length === 0) {
									handlerParams = [W_DEFAULT_KEYBOARD_PARAM]; //When no keyCode parameter is given, register a general keyboard handler
								}

								handlerParams.reduce(function (res, param) {
									return res.concat(_this5.callbacks.keyboard.add(object[objKey].bind(object), priority, +param));
								}, []);
								break;
						}
					});
				} else {
					//Handler name is a simple string
					if (typeof object[name] !== 'function') {
						//The object doesn't implement this handler
						return;
					}
					switch (name) {
						case _this5.handlerNames.NEAR_VIEW:
							//Handle nearView differently
							var el = object.$element || object.$el; //Get the related element for this object
							if (el instanceof jQuery) {
								el = el[0];
							}
							_this5.callbacks.nearView.add(object[name].bind(object), priority, el); //Register the handler
							break;

						default:
							_this5._getCallbackQueueForHandlerName(name).add(object[name].bind(object), priority); //Register the handler
							break;
					}
				}
			});
		}

		//Toggle fullscreen

	}, {
		key: 'toggleFullscreen',
		value: function toggleFullscreen(set) {
			var doc = window.document,
			    docEl = doc.documentElement,
			    requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen,
			    cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen,
			    isFullscreen = !!(doc.fullscreenElement || doc.mozFullScreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement);

			if (typeof set === 'undefined') {
				//Argument omitted, toggle fullscreen state
				set = !isFullscreen;
			}

			if (set && !isFullscreen) {
				requestFullScreen.call(docEl);
			} else if (!set && isFullscreen) {
				cancelFullScreen.call(doc);
			}
		}

		//========================================================

	}, {
		key: '_resizeHandler',
		value: function _resizeHandler() {
			var _this6 = this;

			this.width = this.$window.outerWidth(true);
			this.height = this.$window.outerHeight();

			//Resize in any direction start
			if (!this._flags.resizingWidth && !this._flags.resizingHeight) {
				this.callbacks.resize.general.fire(this.handlerNames.RESIZE_START);
				this.callbacks.resize.start.fire();
			}

			if (this.widthLast !== this.width) {
				//Resize width start
				if (!this._flags.resizingWidth) {
					this._flags.resizingWidth = true;
					this.callbacks.resize.general.fire(this.handlerNames.RESIZE_WIDTH_START);
					this.callbacks.resize.width.start.fire();
				}

				//While resizing width
				this.callbacks.resize.general.fire(this.handlerNames.RESIZE_WIDTH_ACTIVE);
				this.callbacks.resize.width.active.fire();

				//Resize width end
				clearTimeout(this._debounce.resizeWidthTimeoutId);
				this._debounce.resizeWidthTimeoutId = setTimeout(function () {
					_this6._getLayout();
					_this6._flags.resizingWidth = false;
					_this6.callbacks.resize.general.fire(_this6.handlerNames.RESIZE_WIDTH_END);
					_this6.callbacks.resize.width.end.fire();
				}, W_DEFAULT_DEBOUNCE_TIME);
			}

			if (this.heightLast !== this.height) {
				//Resize height start
				if (!this._flags.resizingHeight) {
					this._flags.resizingHeight = true;
					this.callbacks.resize.general.fire(this.handlerNames.RESIZE_HEIGHT_START);
					this.callbacks.resize.height.start.fire();
				}

				//While resizing height
				this.callbacks.resize.general.fire(this.handlerNames.RESIZE_HEIGHT_ACTIVE);
				this.callbacks.resize.height.active.fire();

				//Resize height end
				clearTimeout(this._debounce.resizeHeightTimeoutId);
				this._debounce.resizeHeightTimeoutId = setTimeout(function () {
					_this6._getLayout();
					_this6._flags.resizingHeight = false;
					_this6.callbacks.resize.general.fire(_this6.handlerNames.RESIZE_HEIGHT_END);
					_this6.callbacks.resize.height.end.fire();
				}, W_DEFAULT_DEBOUNCE_TIME);
			}

			//While resizing in any direction
			this.callbacks.resize.general.fire(this.handlerNames.RESIZE_ACTIVE);
			this.callbacks.resize.active.fire();

			//Resize in any direction end
			clearTimeout(this._debounce.resizeTimeoutId);
			this._debounce.resizeTimeoutId = setTimeout(function () {
				_this6._getLayout();
				_this6.callbacks.resize.general.fire(_this6.handlerNames.RESIZE_END);
				_this6.callbacks.resize.end.fire();
			}, W_DEFAULT_DEBOUNCE_TIME);

			this.widthLast = this.width; //Update last value
			this.heightLast = this.height;
		}
	}, {
		key: '_scrollHandler',
		value: function _scrollHandler() {
			var _this7 = this;

			this.top = this.$window.scrollTop();
			this.scrollDirection = Helpers.sign(this.top - this.topLast);

			//Scroll start
			if (!this._flags.scrolling) {
				this._flags.scrolling = true;
				this.callbacks.resize.general.fire(this.handlerNames.SCROLL_START);
				this.callbacks.scroll.start.fire();
			}

			//While scrolling
			this.callbacks.resize.general.fire(this.handlerNames.SCROLL_ACTIVE);
			this.callbacks.scroll.active.fire();

			//Scroll end
			clearTimeout(this._debounce.scrollTimeoutId);
			this._debounce.scrollTimeoutId = setTimeout(function () {
				_this7._flags.scrolling = false;
				_this7.callbacks.scroll.general.fire(_this7.handlerNames.SCROLL_END);
				_this7.callbacks.scroll.end.fire();
			}, W_DEFAULT_DEBOUNCE_TIME);

			this.topLast = this.top; //Update last value
		}
	}, {
		key: '_keyUpHandler',
		value: function _keyUpHandler(e) {
			this.callbacks.keyboard.fire(e);
		}
	}, {
		key: '_visibilityHandler',
		value: function _visibilityHandler() {
			this.callbacks.visibility.fire(this.isWindowFocused = !document.hidden);
		}
	}, {
		key: '_getLayout',
		value: function _getLayout() {
			var oldLayout = this.layout;
			var oldLayoutGroup = this.layoutGroup;
			var currentBreakpoint = this.breakpoints.find(function (b) {
				return window.matchMedia('(min-width: ' + b.from + 'px) and (max-width: ' + b.to + 'px)').matches;
			});

			if (currentBreakpoint) {
				this.layout = currentBreakpoint.layout;
				this.layoutGroup = currentBreakpoint.layoutGroup;
			}
			if (oldLayout !== this.layout && this.layout !== null) {
				//Layout changed
				this.callbacks.layout.fire(this.layout, oldLayout);
			}
			if (oldLayoutGroup !== this.layoutGroup && this.layoutGroup !== null) {
				//Layout group changed
				this.callbacks.layoutGroup.fire(this.layoutGroup, oldLayoutGroup);
			}
		}
	}, {
		key: '_scrollCallbackQueueFactory',
		value: function _scrollCallbackQueueFactory() {
			var _this8 = this;

			var q = new CallbackQueue();
			if (!this._flags.isScrollBound) {
				q.onAfterAdd(function () {
					if (!_this8._flags.isScrollBound) {
						_this8._flags.isScrollBound = true;
						_this8.$window.scroll(_this8._scrollHandler.bind(_this8));
					}
				});
			}
			return q;
		}
	}, {
		key: '_resizeCallbackQueueFactory',
		value: function _resizeCallbackQueueFactory() {
			var _this9 = this;

			var q = new CallbackQueue();
			if (!this._flags.isResizeBound) {
				q.onAfterAdd(function () {
					if (!_this9._flags.isResizeBound) {
						_this9._flags.isResizeBound = true;
						_this9.$window.resize(_this9._resizeHandler.bind(_this9));
					}
				});
			}
			return q;
		}
	}, {
		key: '_keyUpCallbackQueueFactory',
		value: function _keyUpCallbackQueueFactory() {
			var _this10 = this;

			var q = new CallbackQueue();
			q.addTransformer(function (handler, priority, keyCode) {
				return function (e) {
					//Return a function that calls the handler only on correct keyCode
					if (keyCode === e.keyCode || keyCode === W_DEFAULT_KEYBOARD_PARAM) {
						handler(e);
					}
				};
			});
			if (!this._flags.isKeyUpBound) {
				q.onAfterAdd(function () {
					if (!_this10._flags.isKeyUpBound) {
						_this10._flags.isKeyUpBound = true;
						_this10.$document.keyup(_this10._keyUpHandler.bind(_this10));
					}
				});
			}
			return q;
		}
	}, {
		key: '_getCallbackQueueForHandlerName',
		value: function _getCallbackQueueForHandlerName(name) {
			switch (name) {
				case this.handlerNames.INIT:
					return this.callbacks.init;
				case this.handlerNames.SCROLL:
					return this.callbacks.scroll.general;
				case this.handlerNames.SCROLL_START:
					return this.callbacks.scroll.start;
				case this.handlerNames.SCROLL_ACTIVE:
					return this.callbacks.scroll.active;
				case this.handlerNames.SCROLL_END:
					return this.callbacks.scroll.end;
				case this.handlerNames.RESIZE:
					return this.callbacks.resize.general;
				case this.handlerNames.RESIZE_START:
					return this.callbacks.resize.start;
				case this.handlerNames.RESIZE_ACTIVE:
					return this.callbacks.resize.active;
				case this.handlerNames.RESIZE_END:
					return this.callbacks.resize.end;
				case this.handlerNames.RESIZE_WIDTH_START:
					return this.callbacks.resize.width.start;
				case this.handlerNames.RESIZE_WIDTH_ACTIVE:
					return this.callbacks.resize.width.active;
				case this.handlerNames.RESIZE_WIDTH_END:
					return this.callbacks.resize.width.end;
				case this.handlerNames.RESIZE_HEIGHT_START:
					return this.callbacks.resize.height.start;
				case this.handlerNames.RESIZE_HEIGHT_ACTIVE:
					return this.callbacks.resize.height.active;
				case this.handlerNames.RESIZE_HEIGHT_END:
					return this.callbacks.resize.height.end;
				case this.handlerNames.LAYOUT:
					return this.callbacks.layout;
				case this.handlerNames.LAYOUT_GROUP:
					return this.callbacks.layoutGroup;
				case this.handlerNames.VISIBILITY:
					return this.callbacks.visibility;
				case this.handlerNames.KEYBOARD:
					return this.callbacks.keyboard;
			}
			if (this.handlerNames.KEYBOARD.test(name)) {
				return this.callbacks.keyboard;
			}
			return undefined;
		}
	}]);

	return WebPage;
}();
window.w = new WebPage();

;;var Preload = {
	retinaSuffix: '__2',

	isRetina: window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches) || window.devicePixelRatio && window.devicePixelRatio > 1.3,

	//Load a single image
	image: function image(_image, callback) {
		return this._createBatch([_image], null, callback);
	},


	//Load multiple images at once
	images: function images(_images, callbackAll, callbackOne) {
		return this._createBatch.apply(this, arguments);
	},


	//Find images to load in an element
	imagesInContainer: function imagesInContainer(container, callbackAll, callbackOne) {
		container = $(container);
		var $elements = container.find('[data-lazy-src]');
		var images = [];
		$elements.each(function (idx, el) {
			var data = $(el).data('lazy-src');
			if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
				if (typeof data.key === 'undefined') {
					data.key = el;
				}
			} else {
				data = {
					key: el,
					0: data
				};
			}
			images.push(data);
		});
		return this._createBatch(images, callbackAll, callbackOne);
	},


	//=============================================================================

	_$cacheElement: null,

	_createBatch: function _createBatch(images, callbackAll, callbackOne) {
		var batch = {
			images: images,
			totalCount: images.length,
			completedCount: 0,
			callbackOne: callbackOne,
			callbackAll: callbackAll
		};
		return Preload._processBatch(batch);
	},
	_processBatch: function _processBatch(batch) {
		var _this11 = this;

		$.each(batch.images, function (key, image) {
			var imagePath = null;

			if ((typeof image === 'undefined' ? 'undefined' : _typeof(image)) === 'object') {
				if (typeof image.key !== 'undefined') {
					key = image.key;
					delete image.key;
				}
				$.each(image, function (fromWidth, path) {
					//Figure out resolution dependency
					if (window.matchMedia('(min-width: ' + parseInt(fromWidth) + 'px)').matches) {
						imagePath = path;
					}
				});
			} else {
				//String image path
				imagePath = image;
			}

			if (!imagePath) {
				//Path didn't pass the filter
				batch.totalCount--;
				return;
			}

			if (!_this11.isRetina && _this11.retinaSuffix) {
				imagePath = imagePath.replace(_this11.retinaSuffix, ''); //Remove the retina suffix if not on a retina display
			}

			var img = new Image();
			img.onload = function () {
				//When the image has finished loading
				Preload._cacheImage(this);
				var progress = ++batch.completedCount / batch.totalCount * 100; //Update progress

				//Fire callbacks
				if (typeof batch.callbackOne === 'function') {
					batch.callbackOne(progress, imagePath, key);
				}
				if (batch.completedCount === batch.totalCount && typeof batch.callbackAll === 'function') {
					batch.callbackAll(progress);
				}
			};
			img.src = imagePath; //Start loading the image
		});

		return batch.totalCount > 0;
	},


	_cacheImage: function _cacheImage(image) {
		if (!this._$cacheElement) {
			$('body').append(this._$cacheElement = $('<div id="preloaderCacheElement" style="height: 0; overflow: hidden;">'));
		}
		this._$cacheElement.append(image);
	}
};

;;var AnimatedSprite = {
	createImg: function createImg($element, imageNumber, animationSpeed) {
		var counter = 0;
		return new TimelineMax({
			repeat: -1,
			repeatDelay: animationSpeed,
			onRepeat: function onRepeat() {
				counter = (counter + 1) % imageNumber;
				TweenMax.set($element, { yPercent: -counter / imageNumber * 100 });
			}
		});
	},
	resetImg: function resetImg($element, timeline) {
		timeline.stop();
		TweenMax.set($element, { yPercent: 0 });
	}

	//createBg() ...

};

;;(function () {
	var _angles;

	var POS_X = 1;
	var NEG_X = 2;
	var POS_Y = 4;
	var NEG_Y = 8;
	var POS_Z = 16;
	var NEG_Z = 32;

	window.IsometricSystem = {
		axis: {
			POS_X: POS_X,
			NEG_X: NEG_X,
			POS_Y: POS_Y,
			NEG_Y: NEG_Y,
			POS_Z: POS_Z,
			NEG_Z: NEG_Z
		},

		angles: (_angles = {}, _defineProperty(_angles, POS_X, Math.PI / 6), _defineProperty(_angles, POS_Y, Math.PI / 2), _defineProperty(_angles, POS_Z, Math.PI * 5 / 6), _angles),

		isAxisNegative: function isAxisNegative(axis) {
			return (axis & 0xaa) > 0;
		},
		getOppositeAxis: function getOppositeAxis(axis) {
			return this.isAxisNegative(axis) ? axis >> 1 : axis << 1;
		}
	};
})();

;;var IsometricMotion = {
	get: function get(axis, distance) {
		if (IsometricSystem.isAxisNegative(axis)) {
			axis = IsometricSystem.getOppositeAxis(axis);
			distance = -distance;
		}

		return {
			x: Helpers.distX(distance, IsometricSystem.angles[axis]),
			y: Helpers.distY(distance, IsometricSystem.angles[axis])
		};
	}
};

;;var SvgLoader = {
	load: function load(filename, cb) {
		$.ajax({
			url: filename,
			dataType: 'text'
		}).done(function (response) {
			cb(response);
		});
	}
};
